<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">

          <div class="col-12">
        
            <!--div class="card" v-if="$gate.isAdmin()"-->
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Roles List</h3>

                <div class="card-tools">
                  
                  <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                      <i class="fa fa-plus-square"></i>
                      Add New
                  </button>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>NO</th>
                      <th>Name</th>
                      <th>Menu Permission</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="(row, rowIndex) in datas.data" :key="row.id">

                      <td>{{rowIndex+1}}</td>
                      <td>{{row.name}}</td>
                      <td>
                        <small v-if="row.is_pelanggan"><strong>Pelanggan</strong>. &nbsp; </small>
                        <small v-if="row.is_invoice"><strong>Invoice</strong>. &nbsp; </small>
                        <small v-if="row.is_laporan"><strong>Laporan</strong>. &nbsp; </small>
                        <small v-if="row.is_keuangan"><strong>Keuangan</strong>. &nbsp; </small>
                        <small v-if="row.is_master"><strong>Master</strong>. &nbsp; </small>
                        <small v-if="row.is_approval"><strong>Approval</strong>. &nbsp; </small>
                      </td>
                      <td>

                        <a href="#" @click="editModal(row)">
                            <i class="fa fa-edit blue"></i>
                        </a>
                        /
                        
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <pagination :data="datas" @pagination-change-page="getResults"></pagination>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>


        <div v-if="!$gate.isAllowed('is_pelanggan')">
            <not-found></not-found>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Create New Roles</h5>
                    <h5 class="modal-title" v-show="editmode">Update Roles Info</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? updateData() : createData()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Nama Role</label>
                            <input v-model="form.name" type="text" name="name"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('name') }" >
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Permission</label>
                            <br/>
                            <div class="form-check">
                                <input type="checkbox" v-model="form.is_pelanggan" name="is_pelanggan" id="is_pelanggan" class="form-check-input"> <label for="is_pelanggan" class="form-check-label">
                                    Menu Pelanggan
                                </label>
                            </div>
                            <div class="form-check">
                                <input type="checkbox" v-model="form.is_invoice" name="is_invoice" id="is_invoice" class="form-check-input"> <label for="is_invoice" class="form-check-label">
                                    Menu Invoice
                                </label>
                            </div>
                            <div class="form-check">
                                <input type="checkbox" v-model="form.is_keuangan" name="is_keuangan" id="is_keuangan" class="form-check-input"> <label for="is_keuangan" class="form-check-label">
                                    Menu Keuangan
                                </label>
                            </div>
                            <div class="form-check">
                                <input type="checkbox" v-model="form.is_laporan" name="is_laporan" id="is_laporan" class="form-check-input"> <label for="is_laporan" class="form-check-label">
                                    Menu Laporan
                                </label>
                            </div>
                            <div class="form-check">
                                <input type="checkbox" v-model="form.is_master" name="is_master" id="is_master" class="form-check-input"> <label for="is_master" class="form-check-label">
                                    Menu Master
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Update</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Create</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    export default {
        data () {
            return {
                editmode: false,
                datas : {},
                form: new Form({
                    id : '',
                    name: '',
                    is_pelanggan: '',
                    is_invoice: '',
                    is_laporan: '',
                    is_master: '',
                    is_keuangan: '',
                }),
            }
        },
        methods: {

            getResults(page = 1) {

                  this.$Progress.start();
                  
                  axios.get('api/role?page=' + page).then(({ data }) => (this.datas = data.data));

                  this.$Progress.finish();
            },
            updateData(){
                this.$Progress.start();
                // console.log('Editing data');
                this.form.put('api/role/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.loadDatas();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },
            editModal(user){
                this.editmode = true;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.fill(user);
            },
            newModal(){
                this.editmode = false;
                this.form.reset();
                $('#addNew').modal('show');
            },
            
            deleteData(id){
                if(id != 1 || id != 2){
                    Swal.fire({
                        title: 'Are you sure?',
                        text: "You won't be able to revert this!",
                        showCancelButton: true,
                        confirmButtonColor: '#d33',
                        cancelButtonColor: '#3085d6',
                        confirmButtonText: 'Yes, delete it!'
                        }).then((result) => {

                            // Send request to the server
                            if (result.value) {
                                    this.form.delete('api/role/'+id).then(()=>{
                                            Swal.fire(
                                            'Deleted!',
                                            'Your file has been deleted.',
                                            'success'
                                            );
                                        // Fire.$emit('AfterCreate');
                                        this.loadDatas();
                                    }).catch((data)=> {
                                    Swal.fire("Failed!", data.message, "warning");
                                });
                            }
                        });
                }else{
                    Swal.fire("Failed!", "Role Tidak Dapat Dihapus", "warning");
                }
            },
          loadDatas(){
            if(this.$gate.isAdmin()){
              axios.get("api/role").then(({ data }) => (this.datas = data.data));
            }
          },
          createData(){

              this.form.post('api/role')
              .then((response)=>{
                  $('#addNew').modal('hide');

                  Toast.fire({
                        icon: 'success',
                        title: response.data.message
                  });

                  this.$Progress.finish();
                  this.loadDatas();

              })
              .catch(()=>{

                  Toast.fire({
                      icon: 'error',
                      title: 'Some error occured! Please try again'
                  });
              })
          }

        },
        mounted() {
            console.log('Roles Component mounted.')
        },
        created() {

            this.$Progress.start();
            this.loadDatas();
            this.$Progress.finish();
        }
    }
</script>